// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__Wc1zW","createdSearch":"index_createdSearch__XQ+eo","custom_table":"index_custom_table__kkbKU"};